export const convertReasonRoute = (reasonRoutes) => {
  let defaultValue = [
    {
      name: 'level_1',
      level: 1,
      title: '',
      subReason: []
    }
  ]
  if (reasonRoutes) {
    const result = reasonRoutes
      .map((reasonRoute) => {
        const level1 = Object.hasOwnProperty.call(reasonRoute, 'level_1')
          ? reasonRoute.level_1
          : null
        return {
          name: 'level_1',
          level: 1,
          title: level1 ? level1.title : '',
          subReason: level1 ? handleGetSubReason(level1) || [] : []
        }
      })
      .filter(Boolean)
    return result.length > 0 ? result : defaultValue
  }

  return defaultValue
}

export const handleGetSubReason = (reasonRoute) => {
  // get recursive function sub wrap up by key level_2, level_3, level_4 , level_n
  const subReason = []
  const keys = Object.keys(reasonRoute)
  keys.forEach((key) => {
    if (key.includes('level_')) {
      reasonRoute[key].forEach((swu) => {
        subReason.push({
          name: key,
          level: +key.split('_')[1],
          title: swu.title,
          subReason: handleGetSubReason(swu)
        })
      })
    }
  })
  return subReason
}



// WEBPACK FOOTER //
// ./src/utils/reason.js